<template>
  <div v-loading="loading" class="dept-tree">
    <el-tree
      v-show="!loading"
      ref="tree"
      :data="treeData"
      :props="defaultProps"
      node-key="key"
      :load="loadDeptUser"
      lazy
      style="width: 250px;"
    >
      <span slot-scope="{ node, data }" class="tree-node">
        <span v-if="!data.isMember" :title="node.label">{{ node.label }}</span>
        <label v-if="data.isMember" class="member-node">
          <el-checkbox
            v-model="data.isChecked"
            :disabled="checkDisabledUser(data.id)"
            @change="onMemberCheck(data)"
          />
          <span>
            <img class="avatar-img" :src="data.avatar">
            <span :title="node.label" class="member-name">{{ node.label }}</span>
          </span>
        </label>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { getTreeData } from '../utils/collection'
import { getDepartmentList, getDepartmentMemberList } from '../utils/get-list'
import { sendNetworkFailedMessage } from '../utils/send-message'

export default {
  name: 'DepartmentTree',
  props: {
    selectedMembers: {
      type: Array,
      default: () => Array.from({ length: 0 })
    },
    disabledUserIds: {
      type: Array,
      default: () => Array.from({ length: 0 })
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      params: {
        count: 100,
        page: 1
      },
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },
      loading: false,
      treeData: Array.from({ length: 0 })
    }
  },
  watch: {
    selectedMembers (newVal, oldVal) {
      const newValSelectedIds = newVal.map(t => t.id)
      const oldValSelectedIds = oldVal.map(t => t.id)

      // 第一次选中
      if (newVal.length === oldVal.length && newVal.length) {
        this.handleCheckNode(newVal[0].id, true)
      }

      // 筛选新增选中的节点
      const addMembers = newVal.filter(t => !oldValSelectedIds.includes(t.id))
      addMembers.forEach(t => {
        this.handleCheckNode(t.id, true)
      })

      // 筛选取消选中的节点
      const removeMembers = oldVal.filter(t => !newValSelectedIds.includes(t.id))
      removeMembers.forEach(t => {
        this.handleCheckNode(t.id, false)
      })
    }
  },
  async mounted () {
    try {
      this.loading = true
      const res = await getDepartmentList()
      this.treeData = getTreeData(res.data.infos)
      this.loading = false
    } catch (error) {
      sendNetworkFailedMessage()
      this.loading = false
    }
  },
  methods: {
    async loadDeptUser (node, resolve) {
      if (node.level === 0) {
        return resolve([])
      }

      try {
        this.params.dept_id = node.data.id
        const res = await getDepartmentMemberList(this.params)
        const resData = res.data
        let newData = []
        const selectedMemberIds = this.selectedMembers.map(t => t.id)
        const memberList = resData.userlist.map((t) => {
          return {
            id: t.userid,
            key: `${t.comp_uid}_${t.userid}`,
            label: t.user_name,
            leaf: true,
            avatar: t.avatar,
            email: t.email,
            phone: t.phone,
            dept: node.data.label, // 父节点的label就是子节点的部门
            isMember: true,
            isChecked: selectedMemberIds.indexOf(t.userid) > -1
          }
        })

        if (node.data.hasChildren) {
          const { data } = await getDepartmentList(node.data.id)
          node.data.children = getTreeData(data.infos)
        }

        if (node.data.children) {
          newData = [
            ...node.data.children,
            ...memberList
          ]
        } else {
          newData = [...memberList]
        }
        resolve(newData)
      } catch (error) {
        sendNetworkFailedMessage()
      }
    },
    initTreeCheckStatus () {
      const selectedMemberKeys = this.selectedMembers.map(t => t.key)
      const treeRef = this.$refs.tree
      let treeNode = null
      selectedMemberKeys && selectedMemberKeys.forEach(key => {
        treeNode = treeRef.getNode(key)
        treeNode && (treeNode.data.isChecked = false)
      })
    },
    checkDisabledUser (id) {
      return this.disabledUserIds.includes(id)
    },
    handleCheckNode (id, status) {
      const treeRef = this.$refs.tree
      const treeNode = treeRef.getNode(id)
      if (treeNode) {
        treeNode.data.isChecked = status
      }
    },
    onMemberCheck (item) {
      this.$emit('onMemberCheck', item)
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin.scss";
.el-dialog.dialog-dept {
  width: 600px;
  .el-dialog__header {
    display: none;
  }
  .dept-body.single-mode {
    .el-checkbox__inner {
      border-radius: 8px;
    }
  }
  .highlight-text {
    font-weight: normal;
    border: 1px solid #ffdb77;
    display: inline;
    background: #fff8c8;
    font-style: normal;
    border-radius: 2px;
  }
  .dept-tree {
    overflow: auto;
    height: 405px;
    .tree-node {
      flex: 1 0 auto;
      .member-node {
        display: block;
        @include textOverflow;
        .el-checkbox {
          float: right;
          margin-right: 10px;
          margin-top: 4px;
        }
        @import '../style/avatar-img.scss';
        .member-name {
          vertical-align: middle;
        }
      }
    }
  }
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset006pxrgba(0, 0, 0, 0.3);
    border-radius: 24px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 24px;
    background: rgba(0, 0, 0, 0.1);
    box-shadow: inset006pxrgba(0, 0, 0, 0.5);
  }
}
</style>
